import styled from '@emotion/styled'
import Alert from '@mui/material/Alert'
import AlertTitle from '@mui/material/AlertTitle'
import { MessageFieldType } from '../integration-form-types'

const FullWidth = styled.div`
  margin: 0 0 20px 0;
  width: 100%;
`
interface MessageFieldProps {
  title?: string
  message: string
  messageType: MessageFieldType
}

export const MessageField = ({ title, message, messageType }: MessageFieldProps) => {
  return (
    <FullWidth>
      <Alert severity={messageType}>
        {title && <AlertTitle>{title}</AlertTitle>}
        {message}
      </Alert>
    </FullWidth>
  )
}
